export default __webpack_public_path__ + "static/media/R5C_8111.99838e48.jpg";